export default __webpack_public_path__ + "static/blob6-d6f80102d0ae2faf0e576ec9bb57ccdb.svg";